import { useQuery } from '@tanstack/react-query';
import { fetchSummary } from '../../../api/notifications';
import { queryKeys } from '../../../api/queryKeys';

export function useNotificationSummary() {
  return useQuery({
    queryKey: queryKeys.notifications.summary,
    queryFn: fetchSummary,
    refetchInterval: 30_000,
    staleTime: 10_000,
  });
}
